module.exports = __webpack_public_path__ + "img/profile.7d85f3bf.svg";